// Update Cycle looks the row name up in Audits/Cycles ("2024/2025" becomes
// "2024_2025"). A core-procedure cycle with no planner record throws
// `reading 'RevisionID'` while the row menu is built.

export const CYCLE_UPDATE_BLOCKED_REASON = "This cycle revision is approved. You must revise the cycle to update it.";

export function updateCycleVisibility(cycles, cycleName) {
    const cycleId = typeof cycleName === "string" ? cycleName.replace("/", "_") : undefined;
    const cycle = cycleId == null ? undefined : cycles?.[cycleId];
    if (cycle == null) return [true, CYCLE_UPDATE_BLOCKED_REASON];
    const revision = cycle.Revisions?.[cycle.RevisionID];
    if (revision == null) return [true, CYCLE_UPDATE_BLOCKED_REASON];
    return [!revision.Locked, CYCLE_UPDATE_BLOCKED_REASON];
}
